import { useContext } from "react";

import Checkbox from "./Checkbox";
import TransformContext from "../store/transform-context";

function Options(props) {
  const transformContext = useContext(TransformContext);

  function setChecked(id, value) {
    switch (id) {
      case "showSyllables": {
        transformContext.setShowSyllables(value);
        break;
      }
      case "showErres": {
        transformContext.setShowErres(value);
        break;
      }
      case "showAproximantes": {
        transformContext.setShowAproximantes(value);
        break;
      }
      case "showOclusivas": {
        transformContext.setShowOclusivas(value);
        break;
      }
      case "showFricativas": {
        transformContext.setShowFricativas(value);
        break;
      }
      case "showSonoras": {
        transformContext.setShowSonoras(value);
        break;
      }
      case "showSinvoz": {
        transformContext.setShowSinvoz(value);
        break;
      }
      case "showUnions": {
        transformContext.setShowUnions(value);
        break;
      }
      default: {
        break;
      }
    }
  }

  return (
    <table>
      <tbody>
        <tr>
          <td>
            <Checkbox
              label="Sílabas"
              id="showSyllables"
              setChecked={setChecked}
            />
          </td>
          <td>
            <Checkbox 
              label="Uniones" 
              id="showUnions" 
              setChecked={setChecked} 
            />
          </td>
          <td>
            <Checkbox
              label="Erres"
              id="showErres"
              setChecked={setChecked}
            />
          </td>
          <td>
            <Checkbox
              label="Aproximantes"
              id="showAproximantes"
              setChecked={setChecked}
            />
          </td>
          <td>
            <Checkbox
              label="Oclusivas"
              id="showOclusivas"
              setChecked={setChecked}
            />
          </td>
          <td>
            <Checkbox
              label="Fricativas"
              id="showFricativas"
              setChecked={setChecked}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default Options;
